import { RouteObject } from "react-router-dom";
import { RouteType } from "shared/routes/types";

const createMainRoute = ({ pathname, Component }: RouteType): RouteObject[] => {
  return Component ? [{ path: pathname, element: <Component /> }] : [];
};

const createNestedRoute = (
  nestedRoute?: Pick<RouteType, "pathname" | "Component">,
): RouteObject[] => {
  return nestedRoute?.Component
    ? [{ path: nestedRoute.pathname, element: <nestedRoute.Component /> }]
    : [];
};

const createElementRoutes = (elements?: RouteType[]): RouteObject[] => {
  if (!elements?.length) return [];

  return elements.flatMap((element) => [
    ...createMainRoute(element),
    ...createNestedRoute(element.nestedRoute),
    ...(element.nestedRoute?.nestedRoutes?.length
      ? generateRoutes(element.nestedRoute.nestedRoutes as RouteType[])
      : []),
  ]);
};

export const generateRoutes = (routes: RouteType[]): RouteObject[] => {
  return routes.flatMap((route) => [
    ...createMainRoute(route),
    ...createNestedRoute(route.nestedRoute),
    ...createElementRoutes(route.elements),
  ]);
};
